<template>
  <div class="training-section-icon-block-item">
    <div
      v-if="icon"
      class="icon-block-icon"
    >
      <img
        :src="getUrl(icon.url)"
        :alt="title || ''"
      />
    </div>
    <div class="icon-block-content">
      <h3
        v-if="title"
        class="icon-block-title"
        v-html="title"
      ></h3>
      <div
        v-if="text"
        class="icon-block-text"
        v-html="markdownToHTML(text || '')"
      ></div>
    </div>
  </div>
</template>

<script>
import getUrl from '@/tools/getUrl';

// Markdown
const md = require('markdown-it')({
  html: true,
  linkify: true,
  typographer: true,
});

export default {
  name: 'TrainingSectionIconBlockItem',
  props: {
    icon: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    markdownToHTML(content) {
      return md.render(content);
    },
    getUrl,
  },
};
</script>

<style lang="scss" scoped>
.training-section-icon-block-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  .icon-block-icon {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    @include wRule(
      height,
      (
        xl: 55,
        lg: 44,
        md: 34,
        sm: 55,
      )
    );

    @include wRule(
      margin-bottom,
      (
        xl: 36,
        lg: 36,
        md: 21,
        sm: 29,
      )
    );

    img {
      display: block;
      flex-shrink: 0;
      max-height: 100%;
      max-width: 100%;
      height: 100%;
    }
  }

  .icon-block-content {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .icon-block-title {
    font-weight: 700;
    line-height: 1.2;
    text-wrap: balance;

    @include wRule(
      font-size,
      (
        xl: 20,
        lg: 18,
        md: 16,
        sm: 25,
      )
    );

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 8,
          lg: 7,
          md: 6,
          sm: 10,
        )
      );
    }
  }

  .icon-block-text {
    font-weight: 400;
    line-height: 1.6;

    @include wRule(
      font-size,
      (
        xl: 20,
        lg: 18,
        md: 16,
        sm: 25,
      )
    );

    ::v-deep(p) {
      margin: 0;

      &:not(:last-child) {
        @include wRule(
          margin-bottom,
          (
            xl: 12,
            lg: 10,
            md: 10,
            sm: 15,
          )
        );
      }
    }

    ::v-deep(ul) {
      list-style: none;
      margin: 0;
      padding: 0;

      li {
        position: relative;
        padding-left: 1em;

        &::before {
          content: '–';
          position: absolute;
          left: 0;
        }

        &:not(:last-child) {
          @include wRule(
            margin-bottom,
            (
              xl: 4,
              lg: 4,
              md: 4,
              sm: 6,
            )
          );
        }
      }
    }
  }
}
</style>
